export const TranslationKey = {
    UnlockedErrorModalNotice: 'pam.accountRecovery.unlocked.error.modal.notice',
    UnlockedErrorModalTitleNotice: 'pam.accountRecovery.unlockLinkExpired.title',
    UnlockSuccessModalNotice: 'pam.accountRecovery.unlocked.success.modal.notice',
    UnlockedSuccessModalTitleNotice: 'pam.accountRecovery.unlocked.success.title',
    SendEmailKey: 'pam.accountRecovery.locked.sendEmail.modal.notice',
    UnlockTitleKey: 'pam.accountRecovery.unlocked.info.title',
    CloseBtnResendLinkKey: 'pam.accountRecovery.resendLink',
    LoginErrorModalNotice: 'pam.accountRecovery.autoLogin.error.modal.notice',
    CloseBtnLoginErrorModal: 'pam.accountRecovery.autoLogin.closeBtn.error.modal',
    LoginErrorModalTitle: 'pam.accountRecovery.autoLogin.error.modal.title.notice',
    SomethingWrongKey: 'pam.accountRecovery.somethingWrong',
};

export const Paths = {
    NoticeEmail: '/static/img/illustrations/account__email-send.svg',
    AccountSuccess: '/static/img/illustrations/account__success.svg',
};

export const PlayerAlternativeChannelError = {
    PlayerTokenExpired: 'PlayerTokenExpired',
    UsePlayerTokenFailed: 'UsePlayerTokenFailed',
} as const;
export type PlayerAlternativeChannelError = typeof PlayerAlternativeChannelError[keyof typeof PlayerAlternativeChannelError];

export const AnalyticsSource = {
    ExpiredLink: 'token_expired',
    FailedAttempts: 'attempts_failed',
};

export const AnalyticsStatus = {
    Success: 'success',
    Error: 'error',
    Expired: 'expiration',
};

export const AnalyticsActions = {
    ScreenLoad: 'screen_load',
    EmailSubmit: 'email_submit',
    Message: 'message',
};
